import { render, staticRenderFns } from "./BalanceVanPreCollapseContent.vue?vue&type=template&id=7698e72d&scoped=true"
import script from "./BalanceVanPreCollapseContent.vue?vue&type=script&lang=js"
export * from "./BalanceVanPreCollapseContent.vue?vue&type=script&lang=js"
import style0 from "./BalanceVanPreCollapseContent.vue?vue&type=style&index=0&id=7698e72d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7698e72d",
  null
  
)

export default component.exports